import { mapState, mapGetters, mapActions } from 'vuex'
import Loading from '@/components/Core/Loading'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'

export default {
  name: 'ServiceSelectFunctionModal',
  components: {
    Loading
  },
  data () {
    return {
      loading: true,
      processing: false,

      // テーブルオプション
      tableColumns: [
        // 'checkbox',
        'functionMstId',
        'functionName',
        'selectButton'
      ],
      tableData: [],
      tableOptions: {
        headings: {
          // checkbox: '',
          functionMstId: '機能ID',
          functionName: '機能名',
          selectButton: ''
        },
        columnsClasses: {
          // checkbox: 'wp-3',
          functionMstId: 'wp-5',
          functionName: '',
          selectButton: 'wp-10 tlc'
        },
        sortable: [
          'functionMstId',
          'functionName'
        ],
        filterable: [],
        texts: Constants.TableOptions.getTexts('機能'),
        perPage: Constants.TableOptions.perPage.modal,
        perPageValues: Constants.TableOptions.perPageValues,
        pagination: Constants.TableOptions.pagination
      },

      // 絞込み
      activeFilters: false,
      filterPerPage: Constants.TablePerPageInitial,

      // チェックリスト
      checkList: [],

      // input
      inpDeliveryTypeId: '',
      inpFunctionId: ''
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      active: state => state.serviceSelectFunctionModal.active,

      // model
      deliveryTypeMstModel: state => state.serviceSelectFunctionModal.deliveryTypeMstModel,
      // functionMstModel: state => state.serviceSelectFunctionModal.functionMstModel,
      relationaFunctionModel: state => state.serviceSelectFunctionModal.relationaFunctionModel,

      // form
      serviceId: state => state.serviceSelectFunctionModal.serviceId,
      functionModel: state => state.serviceFunction.functionModel,

      // confirm
      confirmKey: state => state.confirm.key,
      confirmAccepted: state => state.confirm.accept
    }),
    ...mapGetters({
      isSmartPhone: 'core/isSmartPhone'
    }),

    // list
    deliveryTypeList () {
      return this.deliveryTypeMstModel.map(item => {
        return {
          value: item.deliveryTypeMstUuid,
          label: item.deliveryTypeName
        }
      })
    },
    functionList () {
      if (this.inpDeliveryTypeId === '') {
        return this.relationaFunctionModel.filter(item => item.deliveryTypes.length === 0)
      } else {
        return this.relationaFunctionModel.filter(item => {
          return item.deliveryTypes.findIndex(deliveryType => deliveryType.deliveryTypeMstUuid === this.inpDeliveryTypeId) !== -1
        })
      }
    },
    tablePerPageList () {
      let list = []
      Constants.TablePerPage.forEach(item => list.push({
        value: item,
        label: item
      }))
      return list
    },
    showFilters () {
      return !this.isSmartPhone ||
        this.activeFilters
    },

    checkRegistered () {
      return props => this.checkList.indexOf(props.row.functionMstUuid) === -1
    },

    disableConfirmButton () {
      return this.checkList.length === 0
    }
  },
  watch: {
    '$route' () {
      // ルーティング変更時にコンポーネントを非表示
      this.hide()
    },
    active (to) {
      if (!to) {
        this.hide()
      }
    },
    inpDeliveryTypeId (to) {
      console.log('deliveryTpeMstUuid: ', to)
      this.tableData = $.extend(true, [], this.functionList)
    },
    confirmAccepted: function (to) {
      // 登録
      if (this.confirmKey === 'select') {
        if (to) this.postData()
      }
    }
  },
  methods: {
    ...mapActions({
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
      loadModel: 'serviceSelectFunctionModal/loadModel',
      hide: 'serviceSelectFunctionModal/hide',
      setUpdated: 'serviceSelectFunctionModal/setUpdated'
    }),

    init () {
      this.loading = true

      // データ更新フラグの初期化
      this.setUpdated(false)

      // 選択済み連携CMSのIDをチェックリストに格納
      if (this.functionModel &&
        this.functionModel.length) {
        this.checkList = $.extend(true, [], this.functionModel.map(item => item.functionMstUuid))
      }
      console.log('checkList', this.checkList)

      //
      let functionMstParams = {}

      // データ読出し
      this.loadModel({
        functionMstParams: functionMstParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
          this.tableData = $.extend(true, [], this.functionList)
        })
        .catch(error => {
          this.showError(error || null)
        })
    },
    getViewData (props) {
      let key = props.column
      let value = props.row[key]

      switch (key) {
        case 'checkbox':
          return props.row.functionMstUuid
      }
      return value
    },
    changePage () {
      // console.log(this.$refs.table.page)
    },
    toggleFilters () {
      this.activeFilters = !this.activeFilters
    },
    changePerPage () {
      this.$refs.table.setLimit(this.filterPerPage)
    },

    confirmData () {
      this.showConfirm({
        key: 'select',
        title: '機能の選択',
        body: 'この内容で情報を変更しますか？'
      })
    },
    postData () {
      this.processing = true

      let parameters = {
        serviceUuid: this.serviceId,
        request: {
          functionMstUuid: this.inpFunctionId
        }
      }
      if (this.inpDeliveryTypeId) {
        parameters.request.deliveryTypeMstUuid = this.inpDeliveryTypeId
      }
      console.log('register data', parameters)

      // 登録
      ApiManager.request(
        ['serviceFunction'],
        ['v1ServiceFunctionPost'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            // toast
            this.showToast({
              title: '機能の追加',
              body: '「機能」を追加しました。'
            })
            
            // データ更新フラグを有効
            // 呼び出し元のページで一覧を更新するため
            this.setUpdated(true)

            this.closeModal()

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },

    selectItem (props) {
      this.inpFunctionId = props.row.functionMstUuid

      // 配信タイプ名
      let deliveryTypeName
      try {
        deliveryTypeName = this.deliveryTypeList.filter(item => item.value === this.inpDeliveryTypeId)[0].label
      // eslint-disable-next-line
      } catch (e) {
        deliveryTypeName = null
      }

      // 機能名
      let functionName = props.row.functionName

      // 本文
      let body = ''
      if (deliveryTypeName) {
        body += ('配信タイプ「' + deliveryTypeName + '」、')
      }
      body += ('機能「' + functionName + '」を追加しますか？')

      this.showConfirm({
        key: 'select',
        title: '機能の追加',
        body: body
      })
    },
    
    /**
     * モーダルを閉じる
     */
    closeModal () {
      this.hide()
    }
  }
}